export enum BackgroundPlace {
  FirstPage = 'firstPage',
  Question = 'question',
  IntermediateResult = 'intermediateResult',
  Result = 'result',
}
